'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--LightDown';

var EntypoLightDown = function EntypoLightDown(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,6.797c-1.775,0-3.2,1.426-3.2,3.201c0,1.773,1.425,3.199,3.2,3.199c1.774,0,3.199-1.426,3.199-3.199C13.199,8.223,11.774,6.797,10,6.797z M10,12.047c-1.133,0-2.051-0.916-2.051-2.049c0-1.133,0.918-2.051,2.051-2.051c1.132,0,2.05,0.918,2.05,2.051C12.049,11.131,11.131,12.047,10,12.047z M15,5c-0.312-0.312-0.883-0.248-1.273,0.142c-0.39,0.391-0.453,0.959-0.141,1.272s0.882,0.25,1.273-0.141C15.249,5.883,15.312,5.312,15,5z M5.142,13.729C4.751,14.119,4.688,14.688,5,15s0.882,0.25,1.273-0.141c0.391-0.391,0.454-0.961,0.142-1.273S5.532,13.338,5.142,13.729z M5,5C4.688,5.312,4.751,5.883,5.141,6.273c0.391,0.391,0.961,0.453,1.273,0.141s0.249-0.883-0.142-1.273C5.883,4.752,5.312,4.688,5,5z M13.727,14.857c0.39,0.391,0.96,0.455,1.273,0.143s0.249-0.883-0.142-1.274c-0.391-0.391-0.96-0.453-1.273-0.141S13.337,14.467,13.727,14.857z M10,4.998c0.441,0,0.8-0.447,0.8-1C10.799,3.445,10.441,3,10,3C9.558,3,9.199,3.445,9.199,3.998C9.199,4.551,9.557,4.998,10,4.998z M10,17c0.441,0,0.8-0.447,0.8-1c0-0.553-0.358-0.998-0.799-0.998c-0.442,0-0.801,0.445-0.801,0.998C9.199,16.553,9.557,17,10,17z M5,10c0-0.441-0.45-0.8-1.003-0.8C3.444,9.2,3,9.559,3,10c0,0.442,0.444,0.8,0.997,0.8C4.55,10.8,5,10.442,5,10z M17,10c0-0.441-0.448-0.8-1.001-0.8C15.446,9.2,15,9.559,15,10c0,0.442,0.446,0.8,0.999,0.8C16.552,10.8,17,10.442,17,10z' })
    );
};

exports.default = EntypoLightDown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/LightDown.js
// module id = ./node_modules/react-entypo/lib/entypo/LightDown.js
// module chunks = 2